import { render, staticRenderFns } from "./AnimatedHand.vue?vue&type=template&id=74931734&scoped=true&"
import script from "./AnimatedHand.vue?vue&type=script&lang=js&"
export * from "./AnimatedHand.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedHand.vue?vue&type=style&index=0&id=74931734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74931734",
  null
  
)

component.options.__file = "AnimatedHand.vue"
export default component.exports